import { EMyHomeEstimationTargets } from '../../../../types/estimationTarget';

export const placeholders = {
  [EMyHomeEstimationTargets.flat]: 'Населенный пункт, улица, дом',
  [EMyHomeEstimationTargets.house]: 'Населенный пункт, улица, дом',
  [EMyHomeEstimationTargets.land]: 'Населенный пункт, улица',
};
